import Controller from "@ember/controller";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { changeEmail } from "discourse/lib/user-activation";
import discourseComputed from "discourse-common/utils/decorators";
export default Controller.extend(dt7948.p({
  router: service(),
  accountCreated: null,
  newEmail: null,
  submitDisabled(newEmail, currentEmail) {
    return newEmail === currentEmail;
  },
  updateNewEmail(email) {
    this.set("newEmail", email);
  },
  async changeEmail() {
    try {
      await changeEmail({
        email: this.newEmail
      });
      this.set("accountCreated.email", this.newEmail);
      this.router.transitionTo("account-created.resent");
    } catch (e) {
      popupAjaxError(e);
    }
  },
  cancel() {
    this.router.transitionTo("account-created.index");
  }
}, [["method", "submitDisabled", [discourseComputed("newEmail", "accountCreated.email")]], ["method", "updateNewEmail", [action]], ["method", "changeEmail", [action]], ["method", "cancel", [action]]]));